import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { verifyUser } from "../../redux/slice/userSlice";

const VerifyUserForm = () => {
  const token = useParams().token;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    const data = await dispatch(verifyUser(token)).unwrap();
    if (data) {
      navigate("/login", {
        replace: true,
        state: { message: "Login to continue" },
      });
    }
  };

  return (
    <div className="flex flex-col gap-5">
      {/*  reset button */}
      <div className="flex text-center flex-col mt-4 gap-6">
        <button
          type="submit"
          onClick={handleSubmit}
          className="h-[52px] bg-secondary rounded-md text-primary text-xl font-medium"
        >
          Verify
        </button>
      </div>
    </div>
  );
};

export default VerifyUserForm;
